export default "__VITE_ASSET__cde54031__"